import { Client, Group, GroupMember, Level, Member } from "suus-api"

type ViewContext = {
  level?: Level | null
  level_id?: number | null
  client?: Client | null
  client_id?: number | null
  group?: Group | null
  // group_id alone is not sufficient to decide what name to use.
}

export const getViewContextOfGroup = (group: Group): ViewContext => {
  return {
    group,
    level: group.level,
    level_id: group.level_id,
    client: group.client,
    client_id: group.client_id,
  }
}

function getContextClass(
  context: ViewContext | null
): "Level" | "Client" | null {
  if (context === null) {
    console.warn("ViewContext is null!")
    return null
  }

  if (context.group) {
    return getContextClass({
      level: context.group.level,
      client: context.group.client,
    })
  }
  if (context.level || context.level_id) return "Level"
  if (context.client || context.client_id) return "Client"
  return null
}

// TODO: Find out why context is missing
function _getContextName(
  context: ViewContext,
  internalName: string,
  umbrellaName: string
): string {
  const contextClass = getContextClass(context)
  if (contextClass === "Level") {
    return umbrellaName
  } else if (contextClass === "Client") {
    return internalName
  } else {
    console.warn("contextClass could not be derived from viewContext!", context)
    return internalName
  }
}

const getContextName = (context: ViewContext, member: GroupMember | Member) => {
  if (!member) return ""
  return _getContextName(
    context,
    member.internal_name_short,
    member.umbrella_name_short
  )
}

const getContextNameLong = (
  context: ViewContext,
  member: GroupMember | Member
) =>
  _getContextName(context, member.internal_name_long, member.umbrella_name_long)

const getContextNameShortPropertyName = (context: ViewContext) => {
  const contextClass = getContextClass(context)
  if (contextClass === "Level") {
    return "umbrella_name_short"
  } else {
    return "internal_name_short"
  }
}

export {
  getContextName,
  getContextNameLong,
  ViewContext,
  getContextNameShortPropertyName,
}
